module.exports = __webpack_public_path__ + "static/media/bet-orange-2.8407f5f7.png";